import { render, staticRenderFns } from "./CreateReleaseButton.vue?vue&type=template&id=34b73a7b"
import script from "./CreateReleaseButton.vue?vue&type=script&lang=js"
export * from "./CreateReleaseButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports